import { NAME } from './constants'

export const getIsAuthenticating = (state) => state[NAME].isAuthenticating
export const getIsAuthenticated = (state) => state[NAME].isAuthenticated
export const getWhoAmI = (state) => state[NAME].loggedUser

export const getLoginOtherAccountsList = (state) => state[NAME].loginOtherAccountsList
export const getQrCodeData = (state) => state[NAME].qrCodeData
